<template>
  <div class="form-group password-field-wrapper" :class="gridClass">
    <label v-if="label">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>
    <div class="position-relative">
      <input
        :type="showPassword ? 'text' : 'password'"
        class="form-control password-input"
        :class="inputClass"
        :placeholder="placeholder"
        :value="value"
        @input="onInput"
        :required="required"
        :disabled="disabled"
        autocomplete="new-password"
      />
      <button
        type="button"
        class="btn btn-sm btn-link eye-button"
        @click="togglePassword"
        v-if="!disabled"
      >
        <i :class="showPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"></i>
      </button>
    </div>
    
    <div class="password-requirements mt-2" v-if="showRequirements && value">
      <small :class="hasMinLength ? 'text-success' : 'text-danger'">
        <i :class="hasMinLength ? 'mdi mdi-check-circle' : 'mdi mdi-close-circle'"></i>
        Mínimo 8 caracteres
      </small>
      <br>
      <small :class="hasNumber ? 'text-success' : 'text-danger'">
        <i :class="hasNumber ? 'mdi mdi-check-circle' : 'mdi mdi-close-circle'"></i>
        Mínimo um número
      </small>
      <br>
      <small :class="hasLetter ? 'text-success' : 'text-danger'">
        <i :class="hasLetter ? 'mdi mdi-check-circle' : 'mdi mdi-close-circle'"></i>
        Mínimo uma letra
      </small>
    </div>
    
    <div class="password-requirements mt-2" v-if="matchPassword !== null && value">
      <small :class="passwordsMatch ? 'text-success' : 'text-danger'">
        <i :class="passwordsMatch ? 'mdi mdi-check-circle' : 'mdi mdi-close-circle'"></i>
        {{ passwordsMatch ? 'As senhas coincidem' : 'As senhas não coincidem' }}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormPasswordValidator',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Digite a senha'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    grid: {
      type: String,
      default: '12'
    },
    showRequirements: {
      type: Boolean,
      default: true
    },
    matchPassword: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showPassword: false
    }
  },
  computed: {
    gridClass() {
      return `col-md-${this.grid}`;
    },
    hasMinLength() {
      return this.value && this.value.length >= 8;
    },
    hasNumber() {
      return this.value && /\d/.test(this.value);
    },
    hasLetter() {
      return this.value && /[A-Za-z]/.test(this.value);
    },
    isValid() {
      if (this.matchPassword !== null) {
        return this.value && this.value === this.matchPassword;
      }

      return this.hasMinLength && this.hasNumber && this.hasLetter;
    },
    inputClass() {
      if (!this.value) return '';
      return this.isValid ? 'is-valid border-success' : 'is-invalid border-danger';
    },
    passwordsMatch() {
      if (this.matchPassword === null) return true;
      return this.value === this.matchPassword;
    }
  },
  methods: {
    onInput(event) {
      const value = event.target.value;
      this.$emit('input', value);
      this.$nextTick(() => {
        this.$emit('valid', this.isValid);
      });
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    validate() {
      return this.isValid;
    }
  },
  watch: {
    value() {
      this.$nextTick(() => {
        this.$emit('valid', this.isValid);
      });
    },
    matchPassword() {
      this.$nextTick(() => {
        this.$emit('valid', this.isValid);
      });
    }
  },
  mounted() {
    this.$emit('valid', this.isValid);
  }
}
</script>

<style scoped>
.password-field-wrapper {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.position-relative {
  position: relative;
}

.form-control.is-valid {
  border-color: #28a745 !important;
  background-image: none;
}

.form-control.is-invalid {
  border-color: #dc3545 !important;
  background-image: none;
}

.form-control.is-valid:focus {
  border-color: #28a745 !important;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.form-control.is-invalid:focus {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.password-requirements {
  font-size: 0.875rem;
  line-height: 1.6;
}

.eye-button {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  padding: 0.25rem 0.5rem;
  line-height: 1;
}

.eye-button:focus {
  box-shadow: none;
}

/* Remove o botão nativo de mostrar senha do navegador */
.password-input::-ms-reveal,
.password-input::-ms-clear {
  display: none;
}

.password-input::-webkit-credentials-auto-fill-button,
.password-input::-webkit-contacts-auto-fill-button {
  visibility: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
}
</style>
